import React from "react"
import { useTranslation, useLanguageQuery } from "next-export-i18n"

const Services = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()
  return (
    <div className="w-full bg-white">
      <div className="max-w-7xl mx-auto px-4 py-14">
        <h2 className="title-header-comp pb-11 md:px-4 md:max-w-3xl mx-auto">
          {t("our_virtual_care_service")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {t("virtual_care_service_data").map((items, index) => {
            return (
              <div
                key={index}
                className=" rounded-xl cardBorder transition-all hover:shadow-xl px-4 lg:px-7 py-8"
              >
                <img src={items.image} alt="" className="mb-6" />
                <h1 className="text-lg md:text-xl lg:text-2xl text-dark font-semibold pb-5">
                  {items.title}
                </h1>
                {items.title2 && (
                <h1 className="text-lg md:text-xl lg:text-2xl text-dark font-semibold -mt-5 pb-5">
                  {items.title2}
                </h1>
          )}
                <p className=" md:text-md text-grey text-base font-normal pb-4">
                  {items.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Services
